import React, {
  RefObject,
} from 'react';
import {
  EditableRendererProps,
} from 'core/components/VirtualTable/types';
import NumberTextField from 'core/components/NumberTextField';

export default function EditableNumberField({
  onSubmit,
  value,
  controlRef,
  props = {},
  onChange,
  placeholder,
}: EditableRendererProps<string | number | null | undefined>) {
  return (
    <NumberTextField
      {...props}
      placeholder={placeholder}
      value={value ?? ''}
      inputRef={controlRef as RefObject<HTMLInputElement>}
      onChange={onChange}
      onBlur={() => { onSubmit?.(); }}
    />
  );
}
